/**
 * --------------------------------------------------------------------------------------------
 * EXTERNAL DEPENDENCIES
 * --------------------------------------------------------------------------------------------
 */

import $ from 'jquery';
import 'babel-polyfill';
import 'picturefill';
import 'lazysizes';
import objectFitImages from 'object-fit-images';





/**
 * --------------------------------------------------------------------------------------------
 * CONFIGURATIONS
 * --------------------------------------------------------------------------------------------
 */

(function (ElementProto) {
    if (typeof ElementProto.matches !== 'function') {
        ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
            var element = this;
            var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
            var index = 0;

            while (elements[index] && elements[index] !== element) {
                ++index;
            }

            return Boolean(elements[index]);
        };
    }

    if (typeof ElementProto.closest !== 'function') {
        ElementProto.closest = function closest(selector) {
            var element = this;

            while (element && element.nodeType === 1) {
                if (element.matches(selector)) {
                    return element;
                }

                element = element.parentNode;
            }

            return null;
        };
    }
})(window.Element.prototype);


window.lazySizesConfig = window.lazySizesConfig || {};

window.lazySizesConfig.customMedia = {
    '--mobile': '(min-width: 0) and (max-width: 749px)',
    '--tablet': '(min-width: 750px) and (max-width: 1439px)',
    '--desktop': '(min-width: 1440px)',
};

// // use .lazy instead of .lazyload
window.lazySizesConfig.lazyClass = 'js-lazy-load';
window.lazySizesConfig.loadingClass = 'o-image--loading';
window.lazySizesConfig.loadedClass = 'o-image--loaded';
window.lazySizesConfig.expand = 1000;
window.lazySizesConfig.expFactor = 3;

const $images = Array.from(document.querySelectorAll('.o-image'));

objectFitImages($images);


import initialComponents from './config/initialComponents'

/**
 * --------------------------------------------------------------------------------------------
 * APP DECLARATION
 * --------------------------------------------------------------------------------------------
 */

const App = window.App = {
  components : {},
  services : {},

  $window : $(window),
  $document : $(document),
  $html : $('html'),
  $body : $('body'),
  $wrap : $('.wrap'),
  $overlay: document.querySelector('.js-overlay'),
  $preloader: document.querySelector('.js-preloader'),
  breakpoints: {
      mobile: 320,
      tablet: 750,
      desktop: 1440
  },

  init () {
    loadComponents(initialComponents);
    App.bindElements(App.$body[0]);
    // App.lazyLoadImages();
  },


  /**
   * --------------------------------------------------------------------------------------------
   * Registers a class constructor to the main app
   * --------------------------------------------------------------------------------------------
   */
  registerComponentClass (componentClass) {

    if ( typeof componentClass !== 'function' ) return;

    // Implement decorators if any
    componentClass.decorate();

    App.components[componentClass.prototype.name] = componentClass;

  },


  /**
   * Binds all elements within a given parent to their respective components
   *
   * @param {HTMLElement} container - The parent element whose children will be bound to components
   */
  bindElements (container) {

    if ( !(container instanceof HTMLElement) ) return;

    for ( let componentName in App.components ) {
      let component = App.components[componentName];
      let prototype = component.prototype;
      if ( prototype.selector && typeof component.bindElement === 'function' ) {
        $(container).find(prototype.selector).each(function () {
          component.bindElement(this);
        });
      }
    }

  },
}




/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

function loadComponents ( componentsList = [] ) {
  for ( let component of componentsList ) {
    if ( component in App.components ) continue;

    let Component = require(`./components/${component}`).default
    App.registerComponentClass(Component);
  }
}













/** Load App */
window.$ = $;

$(document).ready(() => App.init());
